import styled, { css, keyframes } from 'styled-components';
import { PulsePropsInterface } from './LocationTypes';

const PulseOpacity = (color: string) => keyframes`
0% {
  transform: scale(0.97);
  box-shadow: 0 0 0 0 ${color};
}

70% {
  transform: scale(1);
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0);
}

100% {
  transform: scale(0.97);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
}
`;

export const WrapperText = styled.div`
  width: 188px;
  flex-shrink: 0;
`;

export const Pulse = styled.div<PulsePropsInterface>`
  ${({ theme, color }) => css`
    display: flex;
    width: ${theme.spacing.km6};
    flex-shrink: 0;
    padding-top: ${theme.spacing.km2};

    :before {
      content: '';
      width: 12px;
      height: 12px;
      border-radius: ${theme.border.radius.circle};
      background: ${color};
      box-shadow: 0px 0px 0px ${theme.border.width.thick} ${color};
      animation: ${PulseOpacity(color)} 1s infinite;
    }
  `}
`;
